import { FaSync, FaChevronRight, FaCommentDots } from 'react-icons/fa'
import { useConversations } from '@/hooks/useChat'
import { useNavigate } from 'react-router-dom'
import Button from '@/components/common/Button/Button'
import routes from '@/routes/routes'
import './ChatList.css'

const ChatList = () => {
    const { data, isLoading, isError, refetch } = useConversations()
    const navigate = useNavigate()
    const list = data || []

    return (
        <div className="chat-list-page">
            {/* Header */}
            <div className="chat-list-header">
                <div className="chat-list-header-content">
                    <h1 className="chat-list-title">Conversaciones</h1>
                    <p className="chat-list-subtitle">{list.length} conversación{list.length !== 1 ? 'es' : ''} activa{list.length !== 1 ? 's' : ''}</p>
                </div>
                <Button variant="secondary" size="md" onClick={() => refetch()}>
                    <FaSync /> Actualizar
                </Button>
            </div>

            <div className="chat-list-container">

                {isLoading ? (
                    <div className="chat-list-loading">
                        <p>Cargando conversaciones...</p>
                    </div>
                ) : isError ? (
                    <div className="chat-list-error">
                        <p>Error al cargar conversaciones</p>
                        <Button variant="primary" onClick={() => refetch()}>Reintentar</Button>
                    </div>
                ) : (
                    <div className="chat-list-items">
                    {list.map((c: any) => {
                        const firstLetter = (c.service_name || 'C')[0].toUpperCase()
                        const lastMessage = c.last_message?.content || 'No hay mensajes'
                        const hasUnread = c.unread_count > 0
                        
                        return (
                            <div 
                                key={c.id} 
                                className={`chat-list-item ${ hasUnread ? 'chat-list-item--unread' : ''}`}
                                onClick={() => navigate(routes.chat.replace(":id", String(c.id)))}
                            >
                                {/* Avatar */}
                                <div className="chat-list-avatar">
                                    <div className="chat-list-avatar-circle">{firstLetter}</div>
                                    {hasUnread && <div className="chat-list-badge">{c.unread_count}</div>}
                                </div>

                                {/* Content */}
                                <div className="chat-list-content">
                                    <div className="chat-list-item-header">
                                        <h3 className="chat-list-item-title">{c.service_name || 'Conversación'}</h3>
                                        {c.last_message?.created && (
                                            <span className="chat-list-time">
                                                {new Date(c.last_message.created).toLocaleDateString('es-PE', { day: 'numeric', month: 'short' })}
                                            </span>
                                        )}
                                    </div>
                                    <p className="chat-list-message">{lastMessage}</p>
                                </div>

                                {/* Arrow */}
                                <FaChevronRight className="chat-list-arrow" />
                            </div>
                        )
                    })}
                    
                    {list.length === 0 && (
                        <div className="chat-list-empty">
                            <FaCommentDots className="chat-list-empty-icon" />
                            <h3 className="chat-list-empty-title">No hay conversaciones</h3>
                            <p className="chat-list-empty-text">Tus conversaciones con proveedores aparecerán aquí cuando inicies un servicio</p>
                        </div>
                    )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default ChatList


